// extracted by mini-css-extract-plugin
module.exports = {"submitButton":"SubmitButton_submitButton__339VS","ltr":"SubmitButton_ltr__3KgJX"};